import React, { lazy, Suspense } from 'react';

//import { getEnvMap } from './envVarMgr.js';
import dataUtil from '../server/dataUtil.js';
import logit from '../server/logit.js';
import seoOrgData_json from './json/seoOrgData.json';
import seoPersonData_json from './json/seoPersonData.json';

export { siteData };
const siteData = (getEnvVarJson, parms) => {
  let getEnvVar = getEnvVarJson;
  let { type, pagePath = '/' } = parms;
  let seoData = {};

  //console.log('siteData: dump params', parms);
  // usage:
  // Get routes - THIS HAD PROBLEMS TO CONSOLIDATE and hence it's still in its own file: src/routeList
  //     MAY WANT TO TRY GENERATING THE LIST inside src/routeList from this file
  //     const routes = siteData({ type: 'routeList' });
  //
  // get navigation options (headers/footers)
  //     return siteData({ type: 'headerOptions' });
  //     return siteData({ type: 'footerOptions' });
  //
  // get seoData   
  //     seoData: {caller, frontmatter = {}, staticDataLoadResp = null, slug = null }
  //
  // get serverData TODO
  //     

  //
  // Unable to support routeList with imports for '*.mdx' files as it complains about unable to load '.mdx' files.
  // This happens loc:devnode and loc:devvite.
  // So, we keep it in a separate file. src/routeList.js
  /*
  const routeList = [
    { path: "/",                    import: () => import("../pages/Home") , module: "../pages/Home"},
    ....
  ]
  */
  /*
  if (!getEnvVar) {
   getEnvVar = getEnvMap();
  }
  */

  let headerOptions;
  let footerOptions;
  if (type == 'headerOptions' || type == 'footerOptions') {
    /*
       { display: 'Inspirations',       path: '/#inspirations',     draft: true,  type: 'page', use: ['hdr','bgr'],      auth: ['y','n'] },
       { display: 'Notes',              path: '/notes',             draft: true,  type: 'page', use: ['hdr','bgr'],      auth: ['y','n'] },


       { display: 'My Nullic',          path: '/mynullic',          draft: true,  type: 'page', use: ['hdr','bgr'],      auth: ['y','n'] },

     */

    // draft: true|false
    // type: page|mdx|ext|     
    // use:  hdr|bgr|dd|ftr
    // auth: y|n
    // path can also be link to a section within a page: path: '/somepage/#section
    const headerPaths = [
      //{ display: 'Home',               path: '/',                  draft: false, type: 'page', use: ['hdr','bgr'],      auth: ['y','n'] },
      { display: 'About',              path: '/about',             draft: true,  type: 'mdx', use: ['ftr','bgr'],       auth: ['n'] },
      { display: 'Get Started',        path: '/getstarted',        draft: true,  type: 'page', use: ['hdr','bgr'],      auth: ['y','n'] },
      { display: 'Pricing',            path: '/pricing',           draft: true,  type: 'page', use: ['hdr','bgr'],      auth: ['y','n'] },
      { display: 'My Nullic',          path: '/mynullic',          draft: true,  type: 'page', use: ['hdr','bgr'],      auth: ['y','n'] },
      { display: 'Blog',               path: '/blog',              draft: false, type: 'page', use: ['hdr','bgr'],      auth: ['y','n'] },
      { display: 'divider',            path: '',                   draft: false, type: 'page', use: ['bgr'],            auth: ['y','n'] },
      { display: 'My Account',         path: '/myaccount',         draft: false, type: 'page', use: ['hdr','bgr'],      auth: ['y','n'] }
    ];

    const footerPaths = [
      { display: 'About',              path: '/about',             draft: true, type: 'mdx', use: ['ftr','bgr'],      auth: ['y', 'n'] },
      { display: 'Privacy',            path: '/privacy',           draft: false, type: 'mdx', use: ['ftr','bgr'],      auth: ['y', 'n'] },
      { display: 'Terms & Conditions', path: '/termsandconditions', draft: false, type: 'mdx', use: ['ftr','bgr'],      auth: ['y', 'n'] },
      { display: 'Contact Us',         path:getEnvVar.contactUsUrl,draft: false, type: 'ext', use: ['ftr','bgr'],      auth: ['y', 'n'] },
    ];

    headerOptions = {
      appLogoFilePath: getEnvVar.APP_LOGO_FILE_PATH || '',
      logoWidth: 48, // 170,   // manually set
      logoHeight: 48, // 69,   // manually set
      logoText: getEnvVar.LOGO_TEXT,
      logoTextColor: '#fa4d00',
      logoTextType: 'plain',   // 'plain' | 'rainbow' 
      logoFont: 'Philosopher',
      logoRainbowColor: '#ff0000',
      appLogoHref: '/',
      headerPaths: headerPaths,
      activeStyle: '2px solid red',
      inactiveStyle: '2px solid transparent',
      navBarHeightOffset: '56px',   // Due to "null " text just after <body> tag. Don't know where it's from
    };

    footerOptions = {
      footerPaths: footerPaths,
      hoverTextColor: '#ff0000',
    }

    /* Future usage for page context menu - social share - will it work in iPad?

       const menuPaths = [
       'Context Menu', 'A', 'B'
       ];

       menuOptions = {
       menuPaths: menuPaths,
       }

     */
  }

  //
  // routes needing data
  //
  // note: All listed routes' component requires code change - access allSrvrData
  if (type == 'routesNeedingData') {
    //return ['/', '/recent', '/blog'];
    return ['/blog'];
  }

  if (type == 'seoData' && pagePath) {
    let title, description, type, path, keywords;

    keywords = ['custom', 'software', 'react'];

    /*
    // Strip out '/pages' from '/pages/xxx'
    // doesn't work for the error page: '/renderer/_error'
    const callerWOPages = caller.substr(6);
    const pos = callerWOPages.lastIndexOf('/')
    let callerWOIndex = callerWOPages;
    if (pos !== -1) {
      callerWOIndex = callerWOPages.substr(0, pos);
    }
    */
    
    //console.log('seoSitePageData pagePath ', pagePath);
    //console.log('seoSitePageData pagePath', pagePath);
    //console.log('seoSitePageData emert', emert);

    /* A Template for seoData can be reviewed at recalls/src/data/seoSitePageData.js
     */

    switch (pagePath) {
    case '/fourofour':
      seoData = {
	type: 'WebPage',
	personSeoCode: 'principal',
	dateModified: '',
	datePublished: '',
	description: 'Sorry. The page you are looking for is not found. It may have moved!',
	keywords: ['consumer', 'institution', 'supplier'],
	path: pagePath,
	slogan: '',
	title: '404 - Page not found.',
      };
      break;
    case '/about':
      seoData = {
	type: 'WebPage',
	personSeoCode: 'principal',
	dateModified: '',
	datePublished: '',
	description: 'Surfacing the deep and unknown nature of awareness. That with which we live every day and yet it is far from the known!',
	keywords: keywords,
	path: pagePath,
	slogan: '',
	title: 'Contemplation And Reflections On Awareness',
      };
      break;
    case '/getstarted':
      seoData = {
	type: 'WebPage',
	personSeoCode: 'principal',
	dateModified: '',
	datePublished: '',
	description: '',
	keywords: ['consumer', 'institution', 'supplier'],
	path: pagePath,
	slogan: '',
	title: '',
      };
      break;
    case '/blog':
      // This seo is for the blog's main landing page   (not for the individual blogs)
      seoData = {
	type: 'BlogIndexPage',
	personSeoCode: 'principal',
	dateModified: Date(),
	datePublished: Date(),
	description: 'All posts written by Nullic author.',
	keywords: ['products', 'food', 'meat', 'vehicles', 'drugs', 'veterinary'],
	path: pagePath,
	slogan: '',
	title: 'Near And Dear And Yet Least Known!',
      };
      break;
    case '/blog/?id':
      seoData = {
	type: 'BlogPage',
	personSeoCode: 'principal',
	dateModified: Date(),
	datePublished: Date(),
	description: '',   //frontmatter.excerpt,
	keywords: ['products', 'food', 'meat', 'vehicles', 'drugs', 'veterinary'],
	path: pagePath,
	pic: '',   //frontmatter.pic,   // '/images/mdxpages/chef-boyardee.jpg',
	slogan: '',
	title: '',   //frontmatter.title,
      };
      break;
    case '/index.html':
    case '/':
      seoData = {
	type: 'WebIndexPage',
	personSeoCode: 'principal',
	dateModified: '',
	datePublished: '',
	description: '',
	keywords: keywords,
	path: pagePath,
	slogan: 'Awesome Awareness is Always Within',
	title: 'Attend To Awareness - Now',
      };
      break;
    case '/privacy':
      seoData = {
	type: 'WebPage',
	personSeoCode: 'principal',
	dateModified: '',
	datePublished: '',
	description: 'Website privacy policy',
	keywords: ['consumer', 'institution', 'supplier'],
	path: pagePath,
	slogan: '',
	title: 'Website privacy policy',
      };
      break;
    case '/myaccount':
      seoData = {
	type: 'WebPage',
	personSeoCode: 'principal',
	dateModified: '',
	datePublished: '',
	description: 'Configure and manage your account, plans and personal preferences',
	keywords: ['signin', 'signout', 'plans', 'preferences'],
	path: pagePath,
	slogan: '',
	title: 'My Account: Manage access, plans and preferences',
      };
      break;
    case '/termsandconditions':
      seoData = {
	type: 'WebPage',
	personSeoCode: 'principal',
	dateModified: '',
	datePublished: '',
	description: 'Our simple and privacy friendly terms and conditions.',
	keywords: ['consumer', 'institution', 'supplier'],
	path: pagePath,
	slogan: '',
	title: 'Website terms and conditions policy',
      };
      break;
    case '/pricing':
      seoData = {
	type: 'WebPage', // 'BlogIndexPage', 'BlogPage', 'MDXPage', 'WebPage', 'WebIndexPage', 'AppPage'
	personSeoCode: '',
	dateModified: '',
	datePublished: '',
	description: 'Pricing details',
	keywords: keywords,
	path: pagePath,
	slogan: '',
	title: 'Plans & Pricing',
      };
      break;
    case '/mynullic':
      seoData = {
	type: 'WebPage', // 'BlogIndexPage', 'BlogPage', 'MDXPage', 'WebPage', 'WebIndexPage', 'AppPage'
	personSeoCode: '',
	dateModified: '',
	datePublished: '',
	description: 'MY NULLIC',
	keywords: keywords,
	path: pagePath,
	slogan: '',
	title: 'My Nullic',
      };
      break;
    default:
      if (pagePath.indexOf('/blog/') !== -1) {
	seoData = {
	  type: 'BlogPage',
	  personSeoCode: 'principal',
	  dateModified: Date(),
	  datePublished: Date(),
	  description: '',   //frontmatter.excerpt,
	  keywords: ['products', 'food', 'meat', 'vehicles', 'drugs', 'veterinary'],
	  path: pagePath,
	  pic: '',   //frontmatter.pic,   // '/images/mdxpages/chef-boyardee.jpg',
	  slogan: '',
	  title: '',   //frontmatter.title,
	};
      }
      else {
	seoData = {
	  type: 'WebPage',
	  personSeoCode: 'principal',
	  dateModified: '',
	  datePublished: '',
	  description:
	    'This page has no description',
	  keywords: ['consumer', 'institution', 'supplier'],
	  path: pagePath,
	  slogan: '',
	  title: 'This page has no title',
	};
      }
      break;
    } // switch

    seoData['getEnvVar'] = getEnvVar;
    seoData['personData'] = seoPersonData_json;
    seoData['orgData'] = seoOrgData_json;

    seoData['isCanonical'] = true;
  }









  
  
  //if (type == 'routeList') {
  //  return routeList;
  //}
  //else
  if (type == 'headerOptions') {
    return headerOptions;
  }
  else
    if (type == 'footerOptions') {
      return footerOptions;
    }
  else
    if (type == 'seoData') {
      return seoData;
    }


};
